import React from "react";
import { connect } from "react-redux";
import { getIcon } from "../../Components/Functions";
import { updateBooking } from "../../Redux/Booking/actions";
import { timeToShorts } from "./secure/Dashboard";

const AvailableDates = ({ data = [], booking, updateBooking }) => {

	const [page, setPage] = React.useState(1)
	const max = 5
	const end = page * max
	const start = end - max
    React.useEffect(() => {
        // eslint-disable-next-line no-undef
        // initListingDates();
    }, [])

	return (
		<div id="availability" className="listing-dates available-dates p-0">
			<div className="dates-head w-100 mt-5">
				<div className="meta w-100 m-0 ">
					<h4 >Choose from the available time slots</h4>
				</div>
			</div>
            <style>
                {`
					

					.available-dates .glide__slide {
						width: 100% !important;
						cursor: pointer;
						margin-bottom: 1rem;
					}

					.selected-date {
						border: 2px solid #37514b !important;
					}
                   .available-dates .glide__slide {
                        width: 100% !important;
                    }

					.listing-dates .available-dates .available-date {
						flex-direction: row;
						align-items: baseline;
						justify-content: space-between;
					}

					.listing-dates .available-dates .available-date .top{
						margin: 0px !important;
					}
                `}
            </style>
			{/*Available dates carousel wrapper*/}
			<div className="available-dates pt-3" >
				<div className="available-dates-inner glide available-dates-glide">
					<div className="glide__track" data-glide-el="track">
						{/*Available dates carousel*/}
						<ul className="glide__slidesx">
							{/*Carousel item*/}
							{data.map((date, i) => {
								if (!(i >= start && i < end)) return <div/>
								const selected = booking?.selected_slots?.findIndex(e => e?.date?.date === date?.date?.date && e.start_time === date?.start_time);
								return (
									<li className="glide__slide" onClick={() => {
										let selecteds = booking?.selected_slots || [];
										if (selected > -1)  {
											selecteds.splice(selected, 1)
										}else{
											selecteds = [...selecteds, date]
										}
										updateBooking({ selected_slots: selecteds })
									}}>
										<div className={`available-date ${selected > -1 ? "selected-date" : ""} `}>
											<div className="top">
												<h4>{date?.date?.date_s}</h4>
												<span>{timeToShorts(`${date?.start_time}-${date?.end_time}`)}</span>
											</div>
											<div className="bottom">
												<button className={`button is-xsmaller ${selected > -1 ? "is-primary" : ""} is-outline is-raised-hover`}>
													{selected > -1 ? "Remove" : "Select"}
												</button>
											</div>
										</div>
									</li>
								);
							})}
						</ul>
						{data?.length - 1 > max && (
						<div>
							{new Array(Math.ceil((data?.length || 1)/max)).fill(1).map((e, i) => {
								return <button className={`button is-smaller is-outline is-raised-hover mr-2 is-rounded is-${i+1 === page ? "primary" : ""}`}  onClick={() => setPage(i+1)} type="button">{i+1}</button>
							})}
						</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};



const mapStateToProps = ({ booking }) => {
	return { booking };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateBooking: (e) => dispatch(updateBooking(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableDates);
